import { render, staticRenderFns } from "./Suggestion.vue?vue&type=template&id=75268ceb&scoped=true&"
import script from "./Suggestion.vue?vue&type=script&lang=js&"
export * from "./Suggestion.vue?vue&type=script&lang=js&"
import style0 from "./Suggestion.vue?vue&type=style&index=0&id=75268ceb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75268ceb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75268ceb')) {
      api.createRecord('75268ceb', component.options)
    } else {
      api.reload('75268ceb', component.options)
    }
    module.hot.accept("./Suggestion.vue?vue&type=template&id=75268ceb&scoped=true&", function () {
      api.rerender('75268ceb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/landing-page/components/Suggestion.vue"
export default component.exports